import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoSolapaAutorizacion } from '@shared/enums/TipoSolapaAutorizacion';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-matriculas-index',
  templateUrl: './matriculas-index.component.html',
  styleUrls: ['./matriculas-index.component.scss']
})
export class MatriculasIndexComponent {

  TipoUsuario = TipoUsuario;
  TipoSolapaAutorizacion = TipoSolapaAutorizacion;

  constructor(private authService : AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
